const dayLength = 24 * 60 * 60 * 1000 // h * m * s * ms

const functions =  {
  addDays: (date, x) => new Date(date.setDate(date.getDate() + x)),
  toYmdString: (date) => {
    // Check type because this is not TypeScript
    // (and using a string in the date constructor can have unexpected
    // consequences, so we raise an warning *at least*)
    let internalDate = null;
    if (typeof date === "string") {
      internalDate = functions.toDate(date);
    } else if (date instanceof Date) {
      internalDate = date;
    } else {
      console.error("Wrong type. Expected string or Date but got " + typeof date);
      return;
    }
    
    // https://stackoverflow.com/a/29774197
    const offset = internalDate.getTimezoneOffset();
    const newDate = new Date(internalDate.getTime() - (offset * 60 * 1000))
    return newDate.toISOString().split('T')[0]
  },
  dayDiff: (d1, d2) => {
    // using UTC to handle DST
    // https://stackoverflow.com/a/17727953
    const utc2 = Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate(), d2.getHours(), d2.getMinutes());
    const utc1 = Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate(), d1.getHours(), d1.getMinutes());
    const diff = Math.floor((utc2 - utc1) / dayLength);
    return diff
  },
  dayDiffFromToday: (date) => {
    const today = new Date();
    return functions.dayDiff(date, today);
  },
  fullDiff(dayDiff) {
    const years = Math.floor(dayDiff / 365.25);
    const months = Math.floor((dayDiff % 365.25) / 30);
    const days = dayDiff % 30;
    return { years, months, days }
  },
  toDate: (date) => {
    if (date === null || date === undefined) return date;
    let internalDate = null;
    if (typeof date === "string") {
      internalDate = functions.parseDateString(date);
    }
    else {
      internalDate = date;
    }
    return new Date(internalDate.getFullYear(), internalDate.getMonth(), internalDate.getDate())
  },
  parseDateString: (str) => {
    // Because new Date(mySickDate) assumes UTC and it breaks my stuff
    const rg = /([0-9]{4})-([0-9]{2})-([0-9]{2})/;
    const parts = str.match(rg);
    const year = parseInt(parts[1]);
    const month = parseInt(parts[2]) - 1; // Because apparently months start at zero in JS
    const day = parseInt(parts[3]);
    const newDate = new Date(year, month, day);
    return newDate;
  }
}

export default functions;